import { useMemo, useState } from 'react';
import { createContainer } from '~/modules/unstated-next-utils/createContainer';
import { useQueryParam } from '~/hooks/useQueryParam';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useAccountInfo } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryResource';
dayjs.extend(utc);
const dayOfWeekCipher = [2, 5, 1, 2, 4, 5, 1];
const monthOfYearCipher = [11, 12, 21, 9, 16, 19, 8, 11, 22, 12, 14, 16];
const encodeToEid = (id) => {
    // id: A1234567890
    const now = dayjs().utcOffset(8);
    const dayOfWeek = now.day(); // Sun ~ Sat = 0 ~ 6
    const monthOfYear = now.month(); // 0 ~ 11
    let engLetter = '';
    let engLetterEncoded = '';
    if (id[0].match(/[A-Z]/)) {
        engLetter = id[0];
        engLetterEncoded = (engLetter.charCodeAt(0) -
            54 +
            dayOfWeekCipher[dayOfWeek] +
            monthOfYearCipher[monthOfYear]).toString();
    }
    const digitPart = engLetterEncoded === '' ? id : id.slice(1);
    const digitEncodedArray = [];
    for (const c of digitPart) {
        const s = String(parseInt(c) * dayOfWeekCipher[dayOfWeek] + monthOfYearCipher[monthOfYear]).padStart(2, '0');
        digitEncodedArray.push(parseInt(s));
    }
    digitEncodedArray.reverse();
    const eid = digitEncodedArray.join('') + engLetterEncoded;
    return eid;
};
const decodeEidToId = (eid) => {
    const now = dayjs().utcOffset(8);
    const dayOfWeek = now.day(); // Sun ~ Sat = 0 ~ 6
    const monthOfYear = now.month(); // 0 ~ 11
    let digitEndPosition = eid.length;
    let engLetter = '';
    if (eid.length === 20 || eid.length === 18) {
        engLetter = String.fromCharCode(parseInt(eid.slice(-2)) - dayOfWeekCipher[dayOfWeek] - monthOfYearCipher[monthOfYear] + 54);
        digitEndPosition = eid.length - 2;
    }
    const digitArray = [];
    eid
        .slice(0, digitEndPosition)
        .match(/.{2}/g)
        ?.forEach(s => {
        const d = (parseInt(s) - monthOfYearCipher[monthOfYear]) / dayOfWeekCipher[dayOfWeek];
        digitArray.push(d);
    });
    digitArray.reverse();
    const id = engLetter + digitArray.join('');
    return id;
};
const useTradingSummaryUserAccount = () => {
    /** 外部連結傳參*/
    const outsideNationalId = useQueryParam('id');
    const outsideEid = useQueryParam('eid');
    const outsideToken = useQueryParam('token');
    /*
    const testId = ['12345678', 'A123456789', 'F12345678']
    testId.forEach( s => {
      console.log(s, encodeToEid(s), decodeEidToId(encodeToEid(s)))
    }
    )*/
    let nationalId = '';
    if (outsideEid && outsideEid?.length >= 16 && outsideEid?.length <= 20) {
        nationalId = decodeEidToId(outsideEid);
    }
    else if (outsideNationalId &&
        outsideNationalId?.length >= 8 &&
        outsideNationalId?.length <= 10) {
        nationalId = outsideNationalId;
    }
    // console.log('nationalId', nationalId, encodeToEid(nationalId))
    const { data: specClientInfo } = useAccountInfo(outsideToken ?? '', nationalId ?? '');
    const clientIdAccounts = useMemo(() => specClientInfo?.accounts ?? [], [specClientInfo?.accounts]);
    const clientName = specClientInfo?.name;
    const [selectedIdAccount, setSelectedIdAccount] = useState('');
    if (clientIdAccounts.length >= 1 && selectedIdAccount === '')
        setSelectedIdAccount(clientIdAccounts[0]);
    return {
        state: {
            clientName,
            nationalId /** 身分證 */,
            clientIdAccounts /** 期貨帳號 */,
            selectedIdAccount,
            outsideToken,
            clientGotWrongKey: !specClientInfo,
        },
        acts: {
            setSelectedIdAccount,
        },
    };
};
export const useTradingSummaryUserAccountState = createContainer(useTradingSummaryUserAccount);
